module.exports = __webpack_public_path__ + "img/intelligentService-3.af5888db.png";